<template>
  <div>
    <div id="captchaBox">
      <i ref="btn"></i>
    </div>
    <div class="tips" v-show="showTips">
      <span>{{ tips }}</span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showTips: false,
      tips: "",
      captchaObj:null,
    };
  },

  props:['lang'],

  methods: {
    showInputTips(text) {
      this.showTips = true;
      this.tips = text;
    },
    GtCaptcha() {
      let _this = this;
      //   此url是极验官网的测试请求地址，加随机数防止缓存
      axios
        .get("/sec/geetest3?t=" + new Date().getTime())
        .then(res => {
          let data = res.data;
          if (data.success > 0) {
            this.$emit("changeVerifyType",1);
            //   初始化极验
            _this.$initGeet(
              {
                gt: data.gt,
                challenge: data.challenge,
                product: "float",
                offline: !data.success,
                https: true,
                lang:_this.lang,
                width: '100%',
              },
              this.handlerEmbed
            );
          }else {
            this.$emit("changeVerifyType",2);
          }
        });
    },
    handlerEmbed(captchaObj) {
      let _this = this;
      this.captchaObj = captchaObj;
      captchaObj.appendTo("#captchaBox");
      //   图形验证成功
      captchaObj.onSuccess(function() {
        var result = captchaObj.getValidate();
        let param = {
          geetest_challenge: result.geetest_challenge,
          geetest_validate: result.geetest_validate,
          geetest_seccode: result.geetest_seccode,
          gt_state: true
        };
        _this.showTips = false;
        // 极验校验的参数，将其传给服务端，进行校验。
        _this.$emit("geetPath", param);
      });
    },
    //重置geet
    reset(){
      this.captchaObj && this.captchaObj.reset();
    }
  },



  created() {
    // 页面创建，调用函数
    this.GtCaptcha();
  }
};
</script>
<style scoped>
.tips {
  font-size: 12px;
  color: #de3131;
  margin-top: 10px;
  text-align: left;
  width: 290px;
  padding: 0 10px;
  /* margin-left: 143px; */
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/geet/geet.vue